export default function StatsBarSection() {
  const stats = [
    { value: '€2.4B+', label: 'Assets Under Management', sub: 'Across five diversified sectors' },
    { value: '47', label: 'Active Investments', sub: 'In 18 countries worldwide' },
    { value: '12.8%', label: 'Avg Annual Return', sub: '5-year trailing performance' },
    { value: '13+', label: 'Years of Excellence', sub: 'UK institutional governance' },
  ];

  return (
    <section className="relative bg-background-50 py-16 md:py-20 border-b border-foreground-100/20">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className="text-center md:text-left animate-fade-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <p className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mb-2 tracking-tight">
                {stat.value}
              </p>
              <p className="text-xs uppercase tracking-[2px] text-primary-600 font-semibold mb-1">
                {stat.label}
              </p>
              <p className="text-foreground-400 text-xs">
                {stat.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}